export default function footer() {
	return (
		<footer>
			<p>Fait avec beaucoup de ❤️, pas mal de 🍔🍟 et peu de 💤</p>
			<p>Dernière mise à jour : Février 2025</p>
		</footer>
	);
}
